<template>
    <div class="pageBox">
        <div class="option">
            <el-select v-model="searchQuery.categoryLv1Id" @change="level1SearchChange" placeholder="请选择一级分类" clearable>
                <el-option v-for="item in level1SearchList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
            <el-select v-model="searchQuery.categoryLv2Id" @change="level2SearchChange" placeholder="请选择二级分类" clearable>
                <el-option v-for="item in level2SearchList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
            <el-input style="flex: .5;" placeholder="输入产品名称、货号、规格进行搜索" v-model="searchQuery.name">
                <el-button slot="append" icon="el-icon-search" @click="getList()"></el-button>
            </el-input>
            <div style="flex: 1;"></div>
            <el-button @click="add()">创建产品</el-button>
        </div>
        <div class="table" ref="table">
            <el-table element-loading-text="数据加载中..." v-loading="loading" :height='height' :data="list" border>
                <el-table-column label="序号" type="index" align="center" width="100">
                </el-table-column>
                <el-table-column prop="productNo" label="货号" align="center" width="120">
                </el-table-column>
                <el-table-column prop="name" label="名称" align="center" width="400">
                </el-table-column>
                <el-table-column prop="categoryLv1Name" label="一级分类" align="center" width="150">
                </el-table-column>
                <el-table-column prop="categoryLv2Name" label="二级分类" align="center" width="150">
                </el-table-column>
                <el-table-column label="规格列表" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.skuList">
                            <el-table :data="JSON.parse(scope.row.skuList)" border>
                                <el-table-column prop="value1" label="规格" align="center">
                                </el-table-column>
                                <el-table-column prop="value2" label="价格" align="center">
                                    <template slot-scope="scope">
                                        <div>¥{{ scope.row.value2 }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="value3" label="库存" align="center">
                                </el-table-column>
                            </el-table>
                        </div>
                        <div v-else>
                            <div>
                                <el-table :data="[]" border>
                                    <el-table-column prop="value1" label="规格" align="center">
                                    </el-table-column>
                                    <el-table-column prop="value2" label="价格" align="center">
                                    </el-table-column>
                                    <el-table-column prop="value3" label="库存" align="center">
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="产品图片" align="center" width="100">
                    <template slot-scope="scope">
                        <el-image style="width: 50px; height: 50px" :src="scope.row.coverImages[0]"
                            :preview-src-list="scope.row.coverImages">
                        </el-image>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="date" label="创建日期" align="center" width="180">
                </el-table-column> -->
                <el-table-column label="操作" align="center" width="200">
                    <template slot-scope="scope">
                        <el-button @click="edit(scope.row)" type="text">编辑</el-button>
                        <el-button @click="remove(scope.row)" type="text">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="bottom">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="current"
                :page-sizes="[20, 40, 60, 80, 100]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog :close-on-click-modal="false" :title="dialogTitle" :visible.sync="dialogShow" width="70%"
            element-loading-text="操作加载中..." v-loading="dialogLoading">
            <el-form label-width="90px">
                <div style="align-items: center;display: flex;gap: 10px;">
                    <div style="flex: 1;">
                        <el-form-item label="产品名称">
                            <el-input v-model="form.name" placeholder="请输入产品名称"></el-input>
                        </el-form-item>
                    </div>
                    <div style="flex: 1;">
                        <el-form-item label="产品货号">
                            <el-input v-model="form.productNo" placeholder="请输入产品货号"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div style="align-items: center;display: flex;gap: 10px;">
                    <div style="flex: 1;">
                        <el-form-item label="一级分类">
                            <el-select style="width: 100%;" v-model="form.categoryLv1Id" @change="level1DialogChange"
                                placeholder="请选择一级分类" clearable>
                                <el-option v-for="item in level1DialogList" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div style="flex: 1;">
                        <el-form-item label="二级分类">
                            <el-select style="width: 100%;" v-model="form.categoryLv2Id" @change="level2DialogChange"
                                placeholder="请选择二级分类" clearable>
                                <el-option v-for="item in level2DialogList" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <!-- <div style="align-items: center;display: flex;gap: 10px;">
                    <div style="flex: 1;">
                        <el-form-item label="产品规格">
                            <el-input v-model="form.specification" placeholder="请输入产品规格"></el-input>
                        </el-form-item>
                    </div>
                    <div style="flex: 1;">
                        <el-form-item label="产品价格">
                            <el-input v-model="form.price" placeholder="请输入产品价格">
                                <template slot="prepend">￥</template>
                            </el-input>
                        </el-form-item>
                    </div>
                </div> -->
                <el-form-item label="规格列表">
                    <el-table stripe :data="skuList" border>
                        <el-table-column label="规格" prop="value1" align="center">
                            <template slot-scope="scope">
                                <el-input placeholder="请输入规格" v-model="scope.row.value1" />
                            </template>
                        </el-table-column>
                        <el-table-column label="价格" prop="value2" align="center">
                            <template slot-scope="scope">
                                <el-input placeholder="请输入价格" v-model="scope.row.value2">
                                    <template slot="prepend">￥</template>
                                </el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="库存" prop="value3" align="center">
                            <template slot-scope="scope">
                                <el-input placeholder="请输入库存" v-model="scope.row.value3" />
                            </template>
                        </el-table-column>
                        <el-table-column align="center">
                            <template slot="header" slot-scope="scope">
                                <el-button size="mini" @click="addSku()">添加</el-button>
                            </template>
                            <template slot-scope="scope">
                                <el-button size="mini" type="danger"
                                    @click="removeSku(scope.$index, scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
                <el-form-item label="产品图片">
                    <el-upload v-if="fileListLoaded && dialogShow" list-type="picture-card"
                        :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-change="handleFileChange"
                        :on-success="handleSuccess" :multiple="false" :file-list="fileList" action=""
                        :auto-upload="false">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="产品介绍">
                    <WangEditor v-model="form.detail" :max-length="2000" :custom-config="editorConfig"
                        @change="handleEditorChange" ref="editorRef" />
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogShow = false">关闭</el-button>
                <el-button type="primary" @click="confirm">确定</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </div>
</template>
<script>
import WangEditor from '@/components/WangEditor'
import { productAdd, productEdit, productRemove, productDetail, productPage, fileRemove, fileUpload, categoryTree } from '../api.js';
export default {
    components: { WangEditor },
    data() {
        return {
            editorConfig: {
                // 扩展菜单
                // menuKeys: ['head', 'bold', 'image', 'code'],
                // 自定义图片上传大小限制
                // uploadImgMaxSize: 5 * 1024 * 1024,
            },
            list: [],
            total: 0,
            size: 20,
            current: 1,
            height: 0,
            loading: true,
            dialogTitle: '',
            dialogShow: false,
            dialogImageUrl: '',
            dialogVisible: false,
            form: {
                productNo: '',
                name: '',
                categoryLv1Id: '',
                categoryLv2Id: '',
                specification: '',
                price: '',
                coverImages: [],
                detail: '',
            },
            fileList: [],
            fileListLoaded: false,
            level1SearchList: [],
            level2SearchList: [],

            level1DialogList: [],
            level2DialogList: [],
            searchQuery: {
                name: '',
                categoryLv1Id: '',
                categoryLv2Id: '',
            },
            dialogImageUrl: '',
            dialogVisible: false,
            dialogLoading: false,

            skuList: [],
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.getElementHeight()
        })
        this.getCategoryList()
        this.getList()
    },
    methods: {
        checkSkuList() {
            let flag = false
            this.skuList.forEach(item => {
                if (!item.value1 || !item.value2 || !item.value3) {
                    flag = true
                }
            })
            return flag
        },
        addSku() {
            this.skuList.push({ value1: "", value2: "", value3: "现货", })
        },
        removeSku(index, row) {
            this.skuList.splice(index, 1)
        },
        getCategoryList() {
            categoryTree().then(res => {
                if (res.code === 0) {
                    let list = res.data
                    list.forEach(item => {
                        item.label = item.name
                        item.value = item.id
                        item.children.forEach(item2 => {
                            item2.label = item2.name
                            item2.value = item2.id
                        })
                    })
                    this.level1SearchList = list
                    this.level1DialogList = list
                }
            })
        },
        handleEditorChange(html) {
            // console.log('富文本内容变化：', html)
        },
        handleSuccess(response, uploadFile) {
        },
        handleRemove(file, fileList) {
        },
        handleFileChange(file, fileList) {
            this.fileList = fileList
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        async confirm() {
            if (!this.form.name) {
                this.$message({
                    duration: 1500,
                    type: 'error',
                    message: '请输入产品名称'
                });
                return
            }
            if (!this.form.productNo) {
                this.$message({
                    duration: 1500,
                    type: 'error',
                    message: '请输入产品货号'
                });
                return
            }
            if (!this.form.categoryLv1Id) {
                this.$message({
                    duration: 1500,
                    type: 'error',
                    message: '请选择一级分类'
                });
                return
            }
            if (!this.form.categoryLv2Id) {
                this.$message({
                    duration: 1500,
                    type: 'error',
                    message: '请选择二级分类'
                });
                return
            }
            if (this.skuList.length == 0) {
                this.$message({
                    duration: 1500,
                    type: 'error',
                    message: '请添加规格列表'
                });
                return
            }
            if (this.checkSkuList()) {
                this.$message({
                    duration: 1500,
                    type: 'error',
                    message: '请输入规格、价格、库存'
                });
                return
            }
            if (this.fileList.length === 0) {
                this.$message({
                    duration: 1500,
                    type: 'error',
                    message: '请上传产品图片'
                });
                return
            }
            if (!this.form.detail) {
                this.$message({
                    duration: 1500,
                    type: 'error',
                    message: '请输入产品介绍'
                });
                return
            }
            this.dialogLoading = true
            this.form.coverImages = []
            console.log(this.fileList);
            for (const item of this.fileList) {
                if (item.raw) {
                    const formData = new FormData();
                    formData.append('file', item.raw);
                    const res = await fileUpload(formData);
                    this.form.coverImages.push(res.data);
                } else {
                    this.form.coverImages.push(item.url);
                }

            }
            if (this.form.id) {
                productEdit({ ...this.form, skuList: this.skuList.length > 0 ? JSON.stringify(this.skuList) : '' }).then(res => {
                    if (res.code === 0) {
                        this.$message({
                            duration: 1500,
                            type: 'success',
                            message: '编辑成功'
                        });
                        this.dialogLoading = false
                        this.dialogShow = false
                        this.getList()
                    }
                })
            } else {
                productAdd({ ...this.form, skuList: this.skuList.length > 0 ? JSON.stringify(this.skuList) : '' }).then(res => {
                    if (res.code === 0) {
                        this.$message({
                            duration: 1500,
                            type: 'success',
                            message: '新增成功'
                        });
                        this.dialogLoading = false
                        this.dialogShow = false
                        this.getList()
                    }
                })
            }
            // const content = this.$refs.editorRef.getContent()
            // console.log('提交内容：', content)
            // this.dialogShow = false
        },
        clearEditor() {
            this.$refs.editorRef.clearContent()
        },
        getList() {
            this.loading = true
            productPage({ current: this.current, size: this.size, ...this.searchQuery }).then(res => {
                if (res.code == 0) {
                    this.list = res.data.list
                    this.total = res.data.total
                    this.loading = false
                }
            })
        },
        add() {
            this.form = {
                productNo: '',
                name: '',
                categoryLv1Id: '',
                categoryLv2Id: '',
                specification: '',
                price: '',
                coverImages: [],
                detail: '',
            }
            this.fileList = []
            this.fileListLoaded = true
            this.dialogTitle = '创建产品'
            this.dialogShow = true
        },
        edit(row) {
            productDetail(row.id).then(res => {
                if (res.code === 0) {
                    this.form = {
                        id: res.data.id,
                        productNo: res.data.productNo,
                        name: res.data.name,
                        categoryLv1Id: res.data.categoryLv1Id,
                        categoryLv2Id: res.data.categoryLv2Id,
                        specification: res.data.specification,
                        price: res.data.price,
                        coverImages: res.data.coverImages,
                        detail: res.data.detail,
                    }
                    this.skuList = res.data.skuList ? JSON.parse(res.data.skuList) : []
                    this.fileList = []
                    res.data.coverImages.forEach(item => {
                        this.fileList.push({ name: item.split('/').pop(), url: item })
                    })
                    let list = this.level1DialogList.filter(item => item.value == res.data.categoryLv1Id)
                    this.level2DialogList = list[0].children
                    this.fileListLoaded = true
                    this.dialogTitle = '编辑产品'
                    this.dialogShow = true
                }
            })
        },
        remove(row) {
            this.$confirm(`确定要删除该产品吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                productRemove(row.id).then(res => {
                    if (res.code == 0) {
                        this.$message({
                            duration: 1500,
                            type: 'success',
                            message: '删除成功'
                        });
                        this.getList()
                    }
                })
            }).catch(() => {
            });
        },
        level1SearchChange(val) {
            this.searchQuery.categoryLv2Id = ''
            if (!val) {
                this.level2SearchList = []
                return
            }
            let list = this.level1SearchList.filter(item => item.value == val)
            this.level2SearchList = list[0].children
            this.current = 1
            this.getList()
        },
        level2SearchChange(val) {
            console.log(val);
            this.current = 1
            this.getList()
        },
        level1DialogChange(val) {
            this.form.categoryLv2Id = ''
            if (!val) {
                this.level2DialogList = []
                return
            }
            let list = this.level1DialogList.filter(item => item.value == val)
            this.level2DialogList = list[0].children
        },
        level2DialogChange(val) {
            console.log(val);
        },
        getElementHeight() {
            const container = this.$refs.table;
            if (container) {
                this.height = container.offsetHeight
            }
        },
        handleSizeChange(val) {
            this.current = 1
            this.size = val
            this.getList()
        },
        handleCurrentChange(val) {
            this.current = val
            this.getList()
        },
    }
}
</script>
<style scoped lang="less">
.pageBox {
    width: 100%;
    height: 100%;
    padding: 20px 50px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .option {
        margin-bottom: 20px;
        display: flex;
        justify-content: flex-end;
        gap: 24px;
    }

    .table {
        flex: 1;
    }

    .bottom {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>